module.exports = __webpack_public_path__ + "static/nader-abou-anas-banner-b72cd9a79fb02e59dff07f55f98b9253.png";